import { motion } from "framer-motion";
import { FiArrowRight } from "react-icons/fi";

import avatar1 from "../../../assets/fox_mascot.png";
import avatar2 from "../../../assets/fox_mascot.png";
import avatar3 from "../../../assets/fox_mascot.png";

const HeroSection = () => {
  return (
    <section
      className="
        relative bg-background dark:bg-darkbg text-textLight dark:text-textDark w-full overflow-hidden"
    >
      {/* Top-aligned content */}
      <div className="h-full w-full">
        <div className="text-center px-6 max-w-3xl mx-auto  md:py-10 py-8">
         

          {/* Heading */}
          <motion.h1
            className="text-3xl sm:text-5xl font-extrabold tracking-tight mb-5 text-textLight dark:text-textDark"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            Discover the perfect online casino tailored to your{" "}
            <span className="text-primary">gaming style.</span>
          </motion.h1>

          {/* Description */}
          <motion.p
            className="text-textLight/80 dark:text-textDark/80 text-base sm:text-lg mb-6 max-w-2xl mx-auto"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
          >
            Explore a curated selection of top-rated casinos that cater to your
            preferences. Enjoy exclusive bonuses and a seamless gaming
            experience that will keep you coming back for more.
          </motion.p>

          {/* CTA */}
          <motion.div
            initial={{ opacity: 0, scale: 0.98 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5 }}
            className="mb-5"
          >
            <a
              href="/casinos"
              className="inline-flex items-center gap-2 bg-primary hover:bg-primary-hover text-white font-semibold px-6 py-3 rounded-md shadow-md transition no-underline"
            >
              Explore the best rated casinos
              <FiArrowRight className="h-4 w-4" />
            </a>
          </motion.div>

          {/* Social proof */}
          <motion.div
            className="flex flex-col items-center gap-2"
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className="flex items-center gap-4">
              <div className="flex -space-x-3">
                <img
                  src={avatar1}
                  alt="Player 1"
                  className="w-10 h-10 rounded-full border-2 border-white dark:border-textDark object-cover"
                />
                <img
                  src={avatar2}
                  alt="Player 2"
                  className="w-10 h-10 rounded-full border-2 border-white dark:border-textDark object-cover"
                />
                <img
                  src={avatar3}
                  alt="Player 3"
                  className="w-10 h-10 rounded-full border-2 border-white dark:border-textDark object-cover"
                />
              </div>
              <div className="flex items-center gap-1 text-star">
                {Array.from({ length: 5 }).map((_, i) => (
                  <svg
                    key={i}
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    className="w-5 h-5"
                  >
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                ))}
              </div>
            </div>

            <p className="text-sm text-textLight/70 dark:text-textDark/70 max-w-xs text-center">
              Trusted by over <span className="font-semibold">3,200</span>{" "}
              satisfied players.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
